@if (showImage()) {
  <img
    class="report-image__image"
    [src]="src()"
    [alt]="alt()"
    (load)="onLoad()"
    (error)="onError()"
  />
} @else if (src()) {
  <mat-icon class="report-image__error">broken_image</mat-icon>
}
